import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-header"
}
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = { class: "facility-name" }
const _hoisted_4 = {
  key: 1,
  class: "popup-loading"
}
const _hoisted_5 = { class: "ltc-info-title" }
const _hoisted_6 = { class: "ltc-info-table" }
const _hoisted_7 = { colspan: "3" }
const _hoisted_8 = { colspan: "3" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { colspan: "3" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { colspan: "3" }
const _hoisted_14 = { class: "ltc-info-title" }
const _hoisted_15 = { class: "ltc-info-table" }
const _hoisted_16 = { colspan: "3" }
const _hoisted_17 = { colspan: "3" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  class: "ltc-info-title",
  style: {"margin-top":"20px"}
}
const _hoisted_20 = { class: "ltc-data-table" }
const _hoisted_21 = { class: "ltc-cell-center" }
const _hoisted_22 = { class: "ltc-cell-center" }
const _hoisted_23 = { class: "ltc-cell-center" }
const _hoisted_24 = { class: "ltc-cell-center" }
const _hoisted_25 = { class: "ltc-cell-center" }
const _hoisted_26 = { class: "ltc-info-title" }
const _hoisted_27 = {
  key: 0,
  class: "ltc-data-table"
}
const _hoisted_28 = { class: "ltc-cell-center" }
const _hoisted_29 = { class: "ltc-cell-center" }
const _hoisted_30 = { class: "ltc-cell-center" }
const _hoisted_31 = { class: "ltc-cell-center" }
const _hoisted_32 = { class: "ltc-cell-center" }
const _hoisted_33 = { class: "ltc-cell-center" }
const _hoisted_34 = {
  key: 1,
  class: "ltc-no-data-msg"
}
const _hoisted_35 = { class: "ltc-info-title" }
const _hoisted_36 = {
  key: 0,
  class: "ltc-update-date"
}
const _hoisted_37 = { class: "ltc-table-scroll" }
const _hoisted_38 = { class: "ltc-data-table ltc-staff-table" }
const _hoisted_39 = { class: "ltc-cell-center ltc-cell-highlight" }
const _hoisted_40 = { class: "ltc-cell-center" }
const _hoisted_41 = { class: "ltc-cell-center" }
const _hoisted_42 = { class: "ltc-cell-center" }
const _hoisted_43 = { class: "ltc-cell-center" }
const _hoisted_44 = { class: "ltc-cell-center" }
const _hoisted_45 = { class: "ltc-cell-center" }
const _hoisted_46 = { class: "ltc-cell-center" }
const _hoisted_47 = { class: "ltc-cell-center" }
const _hoisted_48 = { class: "ltc-cell-center" }
const _hoisted_49 = { class: "ltc-cell-center" }
const _hoisted_50 = { class: "ltc-cell-center" }
const _hoisted_51 = { class: "ltc-cell-center" }
const _hoisted_52 = { class: "ltc-cell-center" }
const _hoisted_53 = { class: "ltc-cell-center" }
const _hoisted_54 = { class: "ltc-cell-center" }
const _hoisted_55 = { class: "ltc-cell-center" }
const _hoisted_56 = { class: "ltc-cell-center" }
const _hoisted_57 = { class: "ltc-cell-center" }
const _hoisted_58 = { class: "ltc-cell-center" }
const _hoisted_59 = { class: "ltc-cell-center" }
const _hoisted_60 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_61 = {
  key: 0,
  class: "ltc-data-table"
}
const _hoisted_62 = { class: "ltc-cell-center ltc-cell-highlight" }
const _hoisted_63 = { class: "ltc-cell-center" }
const _hoisted_64 = { class: "ltc-cell-center" }
const _hoisted_65 = { class: "ltc-cell-center" }
const _hoisted_66 = { class: "ltc-cell-center" }
const _hoisted_67 = { class: "ltc-cell-center" }
const _hoisted_68 = {
  key: 1,
  class: "ltc-no-data-msg"
}
const _hoisted_69 = { class: "ltc-info-title" }
const _hoisted_70 = {
  key: 0,
  class: "ltc-data-table"
}
const _hoisted_71 = { class: "ltc-cell-center" }
const _hoisted_72 = { class: "ltc-cell-center" }
const _hoisted_73 = {
  key: 1,
  class: "ltc-data-table",
  style: {"margin-top":"12px"}
}
const _hoisted_74 = { class: "ltc-cell-center ltc-cell-highlight" }
const _hoisted_75 = { class: "ltc-cell-center" }
const _hoisted_76 = { class: "ltc-cell-center" }
const _hoisted_77 = { class: "ltc-cell-center" }
const _hoisted_78 = { class: "ltc-cell-center" }
const _hoisted_79 = { class: "ltc-cell-center" }
const _hoisted_80 = { class: "ltc-cell-center" }
const _hoisted_81 = { class: "ltc-cell-center" }
const _hoisted_82 = { class: "ltc-cell-center" }
const _hoisted_83 = { class: "ltc-cell-center" }
const _hoisted_84 = { class: "ltc-cell-center" }
const _hoisted_85 = {
  key: 2,
  class: "ltc-no-data-msg"
}
const _hoisted_86 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_87 = {
  key: 3,
  class: "ltc-data-table"
}
const _hoisted_88 = { class: "ltc-cell-center" }
const _hoisted_89 = {
  key: 4,
  class: "ltc-no-data-msg"
}
const _hoisted_90 = {
  class: "ltc-info-title",
  style: {"margin-top":"24px"}
}
const _hoisted_91 = {
  key: 5,
  class: "ltc-data-table"
}
const _hoisted_92 = {
  key: 6,
  class: "ltc-no-data-msg"
}
const _hoisted_93 = { class: "ltc-info-title" }
const _hoisted_94 = {
  key: 0,
  class: "ltc-data-table"
}
const _hoisted_95 = { class: "ltc-cell-right" }
const _hoisted_96 = { class: "ltc-cell-right" }
const _hoisted_97 = { class: "ltc-cell-center" }
const _hoisted_98 = {
  key: 1,
  class: "ltc-no-data-msg"
}
const _hoisted_99 = { class: "ltc-info-title" }
const _hoisted_100 = {
  key: 0,
  class: "ltc-data-table"
}
const _hoisted_101 = { class: "ltc-cell-center" }
const _hoisted_102 = {
  key: 1,
  class: "ltc-no-data-msg"
}
const _hoisted_103 = {
  key: 0,
  class: "sales-empty-state"
}
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { class: "ltc-info-table sales-info-table" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { colspan: "3" }
const _hoisted_109 = {
  key: 0,
  class: "sales-action-zone"
}
const _hoisted_110 = {
  key: 2,
  class: "sales-log-section"
}
const _hoisted_111 = { class: "ltc-info-title" }
const _hoisted_112 = { class: "sales-log-list" }
const _hoisted_113 = { class: "log-icon" }
const _hoisted_114 = { class: "log-body" }
const _hoisted_115 = { class: "log-edit-actions" }
const _hoisted_116 = { class: "log-header" }
const _hoisted_117 = {
  key: 0,
  class: "log-org"
}
const _hoisted_118 = { class: "log-content" }
const _hoisted_119 = { class: "log-meta" }
const _hoisted_120 = { class: "log-date" }
const _hoisted_121 = { class: "log-date-label" }
const _hoisted_122 = { class: "log-date" }
const _hoisted_123 = {
  key: 0,
  class: "log-duration"
}
const _hoisted_124 = {
  key: 0,
  class: "log-admin-actions"
}
const _hoisted_125 = {
  key: 0,
  class: "popup-footer"
}
const _hoisted_126 = { class: "ltc-detail-meta" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { key: 1 }
const _hoisted_129 = { class: "sales-org-name" }
const _hoisted_130 = {
  key: 0,
  class: "sales-user-name"
}
const _hoisted_131 = {
  key: 3,
  class: "popup-error"
}
const _hoisted_132 = ["disabled"]
const _hoisted_133 = ["disabled"]
const _hoisted_134 = { class: "convert-form" }
const _hoisted_135 = { class: "form-group" }
const _hoisted_136 = { class: "id-input-row" }
const _hoisted_137 = ["disabled"]
const _hoisted_138 = {
  key: 0,
  class: "form-hint success"
}
const _hoisted_139 = {
  key: 1,
  class: "form-hint error"
}
const _hoisted_140 = {
  key: 2,
  class: "form-hint"
}
const _hoisted_141 = { class: "form-group" }
const _hoisted_142 = { class: "form-hint" }

import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { crawlApi, salesApi, orgApi, authApi } from '@/services/api';

// Props (embedded 모드 지원)

export default /*@__PURE__*/_defineComponent({
  __name: 'CrawlDetailPopup',
  props: {
    ccNumber: {},
    embedded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const store = useStore();

const loading = ref(true);
const salesLoading = ref(false);
const detail = ref<any>(null);
const detailTab = ref('basic');
const bizGubunMap = ref<any[]>([]);

// 영업 관련
const salesInfo = ref<any>(null);
const salesLogs = ref<any[]>([]);
const stopDialog = ref(false);
const stopReason = ref('');

// 회원가입 ID/PW 설정 다이얼로그
const convertDialog = ref(false);
const idCheckLoading = ref(false);
const convertForm = ref({
  memberId: '',
  memberPw: '',
  idChecked: false,
  idAvailable: false
});

// 로그 수정/삭제 (관리자)
const editingLogIdx = ref<number | null>(null);
const editingLogContent = ref('');

// 스낵바
const snackbar = ref(false);
const snackbarText = ref('');

// 현재 사용자 정보
const currentUser = computed(() => store.getters.currentUser);

// 영업 가시성: 관리자(60+) 또는 장(60,70)이 볼 수 있는 하위 조직 코드 Set
const visibleOrgCodes = ref<Set<string>>(new Set());

// 담당 조직/담당자 정보를 볼 수 있는지 확인
const canSeeSalesDetail = computed(() => {
  if (!salesInfo.value || !currentUser.value) return false;
  if (currentUser.value.roleLevel >= 60) return true;
  if (currentUser.value.roleLevel >= 60) {
    return visibleOrgCodes.value.has(salesInfo.value.org_code);
  }
  return false;
});

// 조직 트리에서 특정 org_code의 모든 하위 조직 코드를 재귀적으로 수집
const collectDescendantCodes = (tree: any[], orgCode: string): string[] => {
  const codes: string[] = [];
  const findAndCollect = (nodes: any[], found: boolean) => {
    for (const node of nodes) {
      if (found || node.org_code === orgCode) {
        codes.push(node.org_code);
        if (node.children) findAndCollect(node.children, true);
        if (!found && node.org_code === orgCode) continue;
      }
      if (!found && node.children) findAndCollect(node.children, false);
    }
  };
  findAndCollect(tree, false);
  return codes;
};

const loadVisibleOrgCodes = async () => {
  if (!currentUser.value) return;
  if (currentUser.value.roleLevel >= 60 && currentUser.value.roleLevel < 60) {
    try {
      const res = await orgApi.getTree();
      const tree = res.data?.data || [];
      const codes = collectDescendantCodes(tree, currentUser.value.orgCode);
      visibleOrgCodes.value = new Set(codes);
    } catch (e) {
      console.error('조직 트리 로드 오류:', e);
    }
  }
};

// 부모 창에 영업 변경 알림 전송
const notifyParentSalesUpdate = () => {
  const ccNumber = detail.value?.main?.cc_number;
  if (!ccNumber) return;
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({
        type: 'salesUpdated',
        ccNumber,
        salesInfo: salesInfo.value ? {
          sales_idx: salesInfo.value.sales_idx,
          sales_status: salesInfo.value.sales_status,
          sales_org_name: salesInfo.value.sales_org_name,
          sales_user_name: salesInfo.value.sales_user_name,
          org_code: salesInfo.value.org_code
        } : null
      }, '*');
    }
  } catch (e) {
    // cross-origin 등 무시
  }
};

// 영업 권한 확인 (영업 시작 당사자 OR 관리자 roleLevel 60+)
const hasPermission = computed(() => {
  if (!salesInfo.value || !currentUser.value) return false;
  // 관리자 (roleLevel 60+)는 항상 권한 있음
  if (currentUser.value.roleLevel >= 60) return true;
  // 영업 시작한 당사자만 권한 있음
  return salesInfo.value.u_idx === currentUser.value.idx;
});

const detailTabs = computed(() => {
  const tabs = [
    { value: 'basic', label: '기본정보', icon: 'mdi-information-outline' },
    { value: 'eval', label: '평가정보', icon: 'mdi-clipboard-check-outline' },
    { value: 'capacity', label: '정원/현원', icon: 'mdi-account-multiple-outline' },
    { value: 'staff', label: '인력현황', icon: 'mdi-account-group-outline' },
    { value: 'facility', label: '시설현황', icon: 'mdi-home-city-outline' },
    { value: 'cost', label: '비급여비용', icon: 'mdi-currency-krw' },
    { value: 'program', label: '프로그램', icon: 'mdi-calendar-star' }
  ];
  
  if (currentUser.value) {
    tabs.push({ value: 'sales', label: '영업관리', icon: 'mdi-handshake-outline' });
  }
  
  return tabs;
});

// 시설현황: 재가시설(주야간보호) 데이터 유무
const hasDayCareData = computed(() => {
  if (!detail.value?.facility?.length) return false;
  return detail.value.facility.some((row: any) => 
    (row.fac_single_room > 0 || row.fac_program_room > 0) || 
    (!row.fac_room_total && !row.fac_room_1)
  );
});

// 시설현황: 요양시설 데이터 유무
const hasNursingHomeData = computed(() => {
  if (!detail.value?.facility?.length) return false;
  return detail.value.facility.some((row: any) => 
    row.fac_room_total > 0 || row.fac_room_1 > 0
  );
});

// 영업 상태 색상/아이콘 (상태값이 한국어로 저장됨)
const getSalesStatusLabel = (status: string) => {
  const labels: Record<string, string> = {
    '영업중': '영업중',
    '회원가입': '회원가입성공'
  };
  return labels[status] || status || '-';
};

const getSalesStatusColor = (status: string) => {
  const colors: Record<string, string> = {
    '영업중': '#1565c0',
    '회원가입': '#2e7d32'
  };
  return colors[status] || '#78909c';
};

const getSalesStatusIcon = (status: string) => {
  const icons: Record<string, string> = {
    '영업중': 'mdi-briefcase-clock',
    '회원가입': 'mdi-check-circle-outline'
  };
  return icons[status] || 'mdi-circle';
};

// 로그 타입 아이콘/색상
const getLogTypeIcon = (type: string) => {
  const icons: Record<string, string> = {
    start: 'mdi-play-circle',
    stop: 'mdi-pause-circle',
    resume: 'mdi-play-circle',
    convert: 'mdi-account-check',
    withdraw: 'mdi-account-remove',
    hide: 'mdi-eye-off',
    unhide: 'mdi-eye'
  };
  return icons[type] || 'mdi-circle';
};

const getLogTypeColor = (type: string) => {
  const colors: Record<string, string> = {
    start: '#1565c0',
    stop: '#c62828',
    resume: '#2e7d32',
    convert: '#2e7d32',
    withdraw: '#ff6f00',
    hide: '#78909c',
    unhide: '#78909c'
  };
  return colors[type] || '#78909c';
};

const getLogTypeLabel = (type: string) => {
  const labels: Record<string, string> = {
    start: '영업중',
    stop: '영업중단',
    resume: '영업재개',
    convert: '회원가입',
    withdraw: '회원탈퇴',
    hide: '숨김',
    unhide: '공개'
  };
  return labels[type] || type;
};

const getLogTypeClass = (type: string) => {
  return {
    'is-start': type === 'start',
    'is-stop': type === 'stop',
    'is-convert': type === 'convert',
    'is-resume': type === 'resume',
    'is-withdraw': type === 'withdraw'
  };
};

const getEndDateLabel = (type: string) => {
  const labels: Record<string, string> = {
    stop: '중단',
    convert: '가입완료',
    withdraw: '탈퇴',
    start: '종료'
  };
  return labels[type] || '종료';
};

const getDuration = (startDate: string, endDate: string) => {
  if (!startDate || !endDate) return '';
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffMs = end.getTime() - start.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return '당일';
  if (diffDays < 30) return `${diffDays}일`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}개월`;
  return `${Math.floor(diffDays / 365)}년 ${Math.floor((diffDays % 365) / 30)}개월`;
};

// 사업구분 파싱
const parseBizGubun = (raw: string) => {
  if (!raw) return [];
  const items = raw.split(',').map(s => s.trim()).filter(Boolean);
  return items.map(item => {
    const match = bizGubunMap.value.find(m => m.cbm_raw?.split(',').some((r: string) => r.trim() === item));
    return { short: match?.cbm_short || item, color: match?.cbm_color || '#607d8b' };
  });
};

// 포맷 유틸
const formatDate = (value: string | null) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const formatDateTime = (value: string | null) => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

const formatCurrency = (value: number | null) => {
  if (!value && value !== 0) return '-';
  return value.toLocaleString() + '원';
};

// 영업 시작 (확인 후 진행)
const startSales = async () => {
  if (!currentUser.value || !detail.value?.main?.cc_number) return;
  
  const facilityName = detail.value.main.cc_name || '해당 시설';
  if (!confirm(`'${facilityName}' 시설의 영업을 시작하시겠습니까?`)) return;
  
  salesLoading.value = true;
  try {
    await salesApi.startSales({
      cc_number: detail.value.main.cc_number,
      org_code: currentUser.value.orgCode,
      org_name: currentUser.value.orgName || '',
      u_idx: currentUser.value.idx,
      u_name: currentUser.value.name || ''
    });
    
    await loadSalesInfo(detail.value.main.cc_number);
    notifyParentSalesUpdate();
    detailTab.value = 'sales';
  } catch (error: any) {
    console.error('영업 시작 오류:', error);
    alert(error.response?.data?.message || '영업 시작 중 오류가 발생했습니다.');
  } finally {
    salesLoading.value = false;
  }
};

// 영업 중단 다이얼로그 열기
const openStopDialog = () => {
  stopReason.value = '';
  stopDialog.value = true;
};

// 영업 중단 (확인 후 진행)
const stopSales = async () => {
  if (!salesInfo.value || !hasPermission.value || !stopReason.value.trim()) return;
  
  const reason = stopReason.value.trim();
  if (!confirm(`사유: "${reason}"\n\n해당 사유로 영업을 중단하시겠습니까?`)) return;
  
  salesLoading.value = true;
  try {
    await salesApi.stopSales(salesInfo.value.sales_idx, {
      stop_reason: reason,
      cc_number: detail.value.main.cc_number,
      org_code: currentUser.value.orgCode,
      org_name: currentUser.value.orgName || '',
      u_idx: currentUser.value.idx,
      u_name: currentUser.value.name || ''
    });
    
    stopDialog.value = false;
    stopReason.value = '';
    await loadSalesInfo(detail.value.main.cc_number);
    notifyParentSalesUpdate();
  } catch (error: any) {
    console.error('영업 중단 오류:', error);
    alert(error.response?.data?.message || '영업 중단 중 오류가 발생했습니다.');
  } finally {
    salesLoading.value = false;
  }
};

// 회원가입 (영업 성공 — 확인 후 ID/PW 설정 모달 표시)
const convertSales = async () => {
  if (!salesInfo.value || !hasPermission.value) return;
  
  const facilityName = detail.value.main?.cc_name || '해당 시설';
  if (!confirm(`'${facilityName}' 시설을 회원가입 시키겠습니까?`)) return;
  
  // 기관기호를 기본값으로 설정
  const ccNumber = detail.value.main?.cc_number || '';
  convertForm.value.memberId = ccNumber;
  convertForm.value.memberPw = ccNumber;
  convertForm.value.idChecked = false;
  convertForm.value.idAvailable = false;
  
  // ID/PW 설정 모달 표시
  convertDialog.value = true;
};

// 아이디 입력 변경 시 중복확인 상태 초기화
const onIdInputChange = () => {
  convertForm.value.idChecked = false;
  convertForm.value.idAvailable = false;
};

// 아이디 중복확인
const checkIdDuplicate = async () => {
  const memberId = convertForm.value.memberId.trim();
  if (!memberId) {
    alert('아이디를 입력해주세요.');
    return;
  }
  
  idCheckLoading.value = true;
  try {
    const response = await authApi.checkIdDuplicate(memberId, 'member');
    const isDuplicate = response.data?.data?.isDuplicate;
    
    convertForm.value.idChecked = true;
    convertForm.value.idAvailable = !isDuplicate;
  } catch (error: any) {
    console.error('ID 중복확인 오류:', error);
    alert('중복확인 중 오류가 발생했습니다.');
    convertForm.value.idChecked = false;
    convertForm.value.idAvailable = false;
  } finally {
    idCheckLoading.value = false;
  }
};

// 회원가입 취소
const cancelConvert = () => {
  convertDialog.value = false;
  convertForm.value.memberId = '';
  convertForm.value.memberPw = '';
  convertForm.value.idChecked = false;
  convertForm.value.idAvailable = false;
};

// 회원가입 실행 (ID/PW 설정 후)
const doConvertSales = async () => {
  if (!salesInfo.value || !hasPermission.value) return;
  
  if (!convertForm.value.memberId.trim()) {
    alert('아이디를 입력해주세요.');
    return;
  }
  
  if (!convertForm.value.idChecked || !convertForm.value.idAvailable) {
    alert('아이디 중복확인을 해주세요.');
    return;
  }
  
  if (!convertForm.value.memberPw.trim()) {
    alert('비밀번호를 입력해주세요.');
    return;
  }
  
  salesLoading.value = true;
  try {
    await salesApi.convertSales(salesInfo.value.sales_idx, {
      cc_number: detail.value.main.cc_number,
      org_code: currentUser.value.orgCode,
      org_name: currentUser.value.orgName || '',
      u_idx: currentUser.value.idx,
      u_name: currentUser.value.name || '',
      member_id: convertForm.value.memberId.trim(),
      member_pw: convertForm.value.memberPw.trim()
    });
    
    convertDialog.value = false;
    convertForm.value.memberId = '';
    convertForm.value.memberPw = '';
    convertForm.value.idChecked = false;
    convertForm.value.idAvailable = false;
    
    await loadSalesInfo(detail.value.main.cc_number);
    notifyParentSalesUpdate();
    snackbarText.value = '회원가입이 완료되었습니다.';
    snackbar.value = true;
  } catch (error: any) {
    console.error('회원가입 처리 오류:', error);
    alert(error.response?.data?.message || '회원가입 처리 중 오류가 발생했습니다.');
  } finally {
    salesLoading.value = false;
  }
};

// 영업 메모 업데이트
const updateSalesNote = async () => {
  if (!salesInfo.value || !hasPermission.value) return;
  
  try {
    await salesApi.updateSales(salesInfo.value.sales_idx, {
      sales_note: salesInfo.value.sales_note,
      org_code: currentUser.value.orgCode
    });
    snackbarText.value = '메모가 저장되었습니다.';
    snackbar.value = true;
  } catch (error) {
    console.error('영업 메모 업데이트 오류:', error);
    snackbarText.value = '메모 저장에 실패했습니다.';
    snackbar.value = true;
  }
};

// 관리자 여부 (대리로그인 시 대리로그인한 권한 기준)
const isAdmin = computed(() => (currentUser.value?.roleLevel || 0) >= 60);

// 로그 수정 시작
const startLogEdit = (log: any) => {
  editingLogIdx.value = log.log_idx;
  editingLogContent.value = log.log_content || '';
};

// 로그 수정 취소
const cancelLogEdit = () => {
  editingLogIdx.value = null;
  editingLogContent.value = '';
};

// 로그 수정 저장
const saveLogEdit = async (logIdx: number) => {
  if (!editingLogContent.value.trim()) return;
  try {
    await salesApi.updateSalesLog(logIdx, editingLogContent.value.trim());
    // 로컬 데이터 갱신
    const log = salesLogs.value.find((l: any) => l.log_idx === logIdx);
    if (log) log.log_content = editingLogContent.value.trim();
    cancelLogEdit();
    notifyParentSalesUpdate();
  } catch (error) {
    console.error('로그 수정 오류:', error);
  }
};

// 로그 삭제 (log_status='deleted'로 마킹 → 조회에서 제외)
const confirmDeleteLog = async (logIdx: number) => {
  if (!confirm('이 이력을 삭제하시겠습니까?')) return;
  try {
    await salesApi.deleteSalesLog(logIdx);
    // 로컬 데이터에서도 제거 (DB에는 남아있음)
    salesLogs.value = salesLogs.value.filter((l: any) => l.log_idx !== logIdx);
    notifyParentSalesUpdate();
  } catch (error) {
    console.error('로그 삭제 오류:', error);
  }
};

// 영업 정보 로드
const loadSalesInfo = async (ccNumber: string) => {
  try {
    const res = await salesApi.getSalesByFacility(ccNumber);
    salesInfo.value = res.data?.data?.sales || null;
    salesLogs.value = res.data?.data?.logs || [];
  } catch (error) {
    console.error('영업 정보 조회 오류:', error);
  }
};

// 데이터 로드
const loadDetail = async (ccNumber: string) => {
  loading.value = true;
  detail.value = null;
  detailTab.value = 'basic';
  
  try {
    const [detailRes, bizRes] = await Promise.all([
      crawlApi.getDetail(ccNumber),
      crawlApi.getBizGubunList()
    ]);
    
    detail.value = detailRes.data?.data || null;
    bizGubunMap.value = bizRes.data?.data || [];
    
    // embedded 모드가 아닐 때만 document.title 변경
    if (!props.embedded && detail.value?.main?.cc_name) {
      document.title = `${detail.value.main.cc_name} - 시설 상세정보`;
    }
    
    if (currentUser.value) {
      await loadSalesInfo(ccNumber);
    }
  } catch (error) {
    console.error('시설 상세 조회 오류:', error);
  } finally {
    loading.value = false;
  }
};

// props.ccNumber 변경 감지 (embedded 모드)
watch(() => props.ccNumber, (newVal) => {
  if (newVal && props.embedded) {
    loadDetail(newVal);
  }
}, { immediate: false });

// route.params.ccNumber 변경 감지 (일반 모드)
watch(() => route.params.ccNumber, (newVal) => {
  if (newVal && !props.embedded) {
    loadDetail(newVal as string);
  }
}, { immediate: false });

onMounted(async () => {
  await loadVisibleOrgCodes();
  
  // embedded 모드면 props에서, 아니면 route에서 ccNumber 가져옴
  const ccNumber = props.embedded ? props.ccNumber : (route.params.ccNumber as string);
  if (ccNumber) {
    loadDetail(ccNumber);
  } else {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["crawl-detail-popup", { 'embedded-mode': __props.embedded }])
  }, [
    (!__props.embedded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_icon, {
            class: "mr-2",
            color: "white"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-hospital-building", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(detail.value?.main?.cc_name || '시설 정보'), 1),
            (detail.value?.main?.cc_biz_gubun)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(parseBizGubun(detail.value.main.cc_biz_gubun), (chip, ci) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: ci,
                    size: "x-small",
                    variant: "flat",
                    color: chip.color
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(chip.short), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary",
            size: "48"
          }),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, "데이터를 불러오는 중...", -1))
        ]))
      : (detail.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_v_tabs, {
              modelValue: detailTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailTab).value = $event)),
              color: __props.embedded ? 'primary' : 'white',
              "bg-color": __props.embedded ? 'white' : 'primary',
              density: "compact",
              class: _normalizeClass({ 'embedded-tabs': __props.embedded })
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailTabs.value, (tab) => {
                  return (_openBlock(), _createBlock(_component_v_tab, {
                    key: tab.value,
                    value: tab.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.icon), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createTextVNode(" " + _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "color", "bg-color", "class"]),
            _createElementVNode("div", {
              class: _normalizeClass(["popup-content", { 'embedded-content': __props.embedded }])
            }, [
              _createVNode(_component_v_window, {
                modelValue: detailTab.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((detailTab).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "basic" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("mdi-information-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createTextVNode(" 기본정보 ", -1))
                      ]),
                      _createElementVNode("table", _hoisted_6, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[18] || (_cache[18] = _createElementVNode("th", null, "시설명", -1)),
                            _createElementVNode("td", _hoisted_7, _toDisplayString(detail.value.main?.cc_name || '-') + "(" + _toDisplayString(detail.value.main?.cc_number) + ")", 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[19] || (_cache[19] = _createElementVNode("th", null, "사업구분", -1)),
                            _createElementVNode("td", _hoisted_8, [
                              (detail.value.main?.cc_biz_gubun)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(parseBizGubun(detail.value.main.cc_biz_gubun), (chip, ci) => {
                                    return (_openBlock(), _createBlock(_component_v_chip, {
                                      key: ci,
                                      size: "small",
                                      variant: "flat",
                                      color: chip.color,
                                      class: "mr-1 mb-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(chip.short), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[20] || (_cache[20] = _createElementVNode("th", null, "소재지", -1)),
                            _createElementVNode("td", _hoisted_10, _toDisplayString(detail.value.main?.cc_addr || '-'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[21] || (_cache[21] = _createElementVNode("th", null, "전화번호", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_tell || '-'), 1),
                            _cache[22] || (_cache[22] = _createElementVNode("th", null, "팩스번호", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_fax || '-'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[23] || (_cache[23] = _createElementVNode("th", null, "이메일", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_email || '-'), 1),
                            _cache[24] || (_cache[24] = _createElementVNode("th", null, "홈페이지", -1)),
                            _createElementVNode("td", null, [
                              (detail.value.main?.cc_web)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: detail.value.main.cc_web,
                                    target: "_blank",
                                    style: {"color":"#1565c0"}
                                  }, _toDisplayString(detail.value.main.cc_web), 9, _hoisted_11))
                                : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[25] || (_cache[25] = _createElementVNode("th", null, "지정일자", -1)),
                            _createElementVNode("td", null, _toDisplayString(formatDate(detail.value.main?.cc_since)), 1),
                            _cache[26] || (_cache[26] = _createElementVNode("th", null, "설치신고일자", -1)),
                            _createElementVNode("td", null, _toDisplayString(formatDate(detail.value.main?.cc_registered)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[27] || (_cache[27] = _createElementVNode("th", null, "운영시간", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_hours || '-'), 1),
                            _cache[28] || (_cache[28] = _createElementVNode("th", null, "주차시설", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_parking || '-'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[29] || (_cache[29] = _createElementVNode("th", null, "교통편", -1)),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(detail.value.main?.cc_transport || '-'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[30] || (_cache[30] = _createElementVNode("th", null, "통합재가급여", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_integrated === 'Y' ? '제공' : '미제공'), 1),
                            _cache[31] || (_cache[31] = _createElementVNode("th", null, "통합재가 유형", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_integrated_type || '-'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[32] || (_cache[32] = _createElementVNode("th", null, "전문인배상책임보험", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_insurance_pro || '-'), 1),
                            _cache[33] || (_cache[33] = _createElementVNode("th", null, "손해배상책임보험", -1)),
                            _createElementVNode("td", null, _toDisplayString(detail.value.main?.cc_insurance_dmg || '-'), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "eval" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode("mdi-clipboard-check-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[35] || (_cache[35] = _createTextVNode("평가정보", -1))
                      ]),
                      _createElementVNode("table", _hoisted_15, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[36] || (_cache[36] = _createElementVNode("th", null, "평가 급여종류", -1)),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(detail.value.main?.eval_type || '-'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[37] || (_cache[37] = _createElementVNode("th", null, "종합등급", -1)),
                            _createElementVNode("td", _hoisted_17, [
                              (detail.value.main?.eval_grade)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    variant: "flat",
                                    color: "primary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(detail.value.main.eval_grade), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                            _createTextVNode("mdi-chart-bar", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[39] || (_cache[39] = _createTextVNode("영역별 등급", -1))
                      ]),
                      _createElementVNode("table", _hoisted_20, [
                        _cache[40] || (_cache[40] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "기관운영"),
                            _createElementVNode("th", null, "환경 및 안전"),
                            _createElementVNode("th", null, "수급자 권리보장"),
                            _createElementVNode("th", null, "급여제공과정"),
                            _createElementVNode("th", null, "급여제공결과")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_21, _toDisplayString(detail.value.main?.eval_management || '-'), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(detail.value.main?.eval_safety || '-'), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(detail.value.main?.eval_rights || '-'), 1),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(detail.value.main?.eval_process || '-'), 1),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(detail.value.main?.eval_result || '-'), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "capacity" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode("mdi-account-multiple-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[42] || (_cache[42] = _createTextVNode("정원/현원 정보", -1))
                      ]),
                      (detail.value.capacity?.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                            _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { rowspan: "2" }, "급여종류"),
                                _createElementVNode("th", { rowspan: "2" }, "정원"),
                                _createElementVNode("th", { colspan: "2" }, "현원"),
                                _createElementVNode("th", { colspan: "2" }, "대기자"),
                                _createElementVNode("th", { rowspan: "2" }, "이용가능")
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "남"),
                                _createElementVNode("th", null, "여"),
                                _createElementVNode("th", null, "남"),
                                _createElementVNode("th", null, "여")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.capacity, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", null, _toDisplayString(row.cap_service || '-'), 1),
                                  _createElementVNode("td", _hoisted_28, _toDisplayString(row.cap_capacity || 0) + "명", 1),
                                  _createElementVNode("td", _hoisted_29, _toDisplayString(row.cap_current_male || 0) + "명", 1),
                                  _createElementVNode("td", _hoisted_30, _toDisplayString(row.cap_current_female || 0) + "명", 1),
                                  _createElementVNode("td", _hoisted_31, _toDisplayString(row.cap_male_wait || 0) + "명", 1),
                                  _createElementVNode("td", _hoisted_32, _toDisplayString(row.cap_female_wait || 0) + "명", 1),
                                  _createElementVNode("td", _hoisted_33, _toDisplayString(row.cap_available || 0) + "명", 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_34, "등록된 정원/현원 정보가 없습니다."))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "staff" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                            _createTextVNode("mdi-account-group-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[45] || (_cache[45] = _createTextVNode("인력현황 ", -1)),
                        (detail.value.main?.staff_update_date)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "최종변경일: " + _toDisplayString(detail.value.main.staff_update_date), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("table", _hoisted_38, [
                          _cache[46] || (_cache[46] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { rowspan: "2" }, "총인원"),
                              _createElementVNode("th", { rowspan: "2" }, "시설장"),
                              _createElementVNode("th", { rowspan: "2" }, [
                                _createTextVNode("사무"),
                                _createElementVNode("br"),
                                _createTextVNode("국장")
                              ]),
                              _createElementVNode("th", { rowspan: "2" }, [
                                _createTextVNode("사회"),
                                _createElementVNode("br"),
                                _createTextVNode("복지사")
                              ]),
                              _createElementVNode("th", { colspan: "2" }, "의사"),
                              _createElementVNode("th", { colspan: "3" }, "간호요원"),
                              _createElementVNode("th", { colspan: "3" }, "요양보호사"),
                              _createElementVNode("th", { rowspan: "2" }, [
                                _createTextVNode("물리"),
                                _createElementVNode("br"),
                                _createTextVNode("치료사")
                              ]),
                              _createElementVNode("th", { rowspan: "2" }, [
                                _createTextVNode("작업"),
                                _createElementVNode("br"),
                                _createTextVNode("치료사")
                              ]),
                              _createElementVNode("th", { rowspan: "2" }, "사무원"),
                              _createElementVNode("th", { rowspan: "2" }, "영양사"),
                              _createElementVNode("th", { rowspan: "2" }, "조리원"),
                              _createElementVNode("th", { rowspan: "2" }, "위생원"),
                              _createElementVNode("th", { rowspan: "2" }, "관리인"),
                              _createElementVNode("th", { rowspan: "2" }, "보조원"),
                              _createElementVNode("th", { rowspan: "2" }, "기타")
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "전임"),
                              _createElementVNode("th", null, "계약"),
                              _createElementVNode("th", null, "간호사"),
                              _createElementVNode("th", null, "조무사"),
                              _createElementVNode("th", null, "치위생사"),
                              _createElementVNode("th", null, "1급"),
                              _createElementVNode("th", null, "2급"),
                              _createElementVNode("th", null, "유예")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_39, _toDisplayString(detail.value.main?.staff_total || 0), 1),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(detail.value.main?.staff_director || 0), 1),
                              _createElementVNode("td", _hoisted_41, _toDisplayString(detail.value.main?.staff_deputy || 0), 1),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(detail.value.main?.staff_social_worker || 0), 1),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(detail.value.main?.staff_doctor_fulltime || 0), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(detail.value.main?.staff_doctor_contract || 0), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(detail.value.main?.staff_nurse || 0), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(detail.value.main?.staff_nurse_aid || 0), 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(detail.value.main?.staff_dental_hyg || 0), 1),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(detail.value.main?.staff_caregiver1 || 0), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(detail.value.main?.staff_caregiver2 || 0), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(detail.value.main?.staff_caregiver_grace || 0), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(detail.value.main?.staff_pt || 0), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(detail.value.main?.staff_ot || 0), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(detail.value.main?.staff_clerk || 0), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(detail.value.main?.staff_dietitian || 0), 1),
                              _createElementVNode("td", _hoisted_55, _toDisplayString(detail.value.main?.staff_cook || 0), 1),
                              _createElementVNode("td", _hoisted_56, _toDisplayString(detail.value.main?.staff_janitor || 0), 1),
                              _createElementVNode("td", _hoisted_57, _toDisplayString(detail.value.main?.staff_guard || 0), 1),
                              _createElementVNode("td", _hoisted_58, _toDisplayString(detail.value.main?.staff_assistant || 0), 1),
                              _createElementVNode("td", _hoisted_59, _toDisplayString(detail.value.main?.staff_other || 0), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("mdi-clock-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[48] || (_cache[48] = _createTextVNode("근속현황 ", -1)),
                        _cache[49] || (_cache[49] = _createElementVNode("span", { class: "ltc-info-note" }, "※ 요양보호사(방문목욕, 방문요양, 방문간호)는 배상보험에 가입된 기준으로 조회됩니다.", -1))
                      ]),
                      (detail.value.tenure?.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_61, [
                            _cache[50] || (_cache[50] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "장기요양요원"),
                                _createElementVNode("th", null, "합계"),
                                _createElementVNode("th", null, "3개월미만"),
                                _createElementVNode("th", null, [
                                  _createTextVNode("3개월이상"),
                                  _createElementVNode("br"),
                                  _createTextVNode("6개월미만")
                                ]),
                                _createElementVNode("th", null, [
                                  _createTextVNode("6개월이상"),
                                  _createElementVNode("br"),
                                  _createTextVNode("1년미만")
                                ]),
                                _createElementVNode("th", null, [
                                  _createTextVNode("1년이상"),
                                  _createElementVNode("br"),
                                  _createTextVNode("2년미만")
                                ]),
                                _createElementVNode("th", null, "2년이상")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.tenure, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", null, _toDisplayString(row.st_position || '-'), 1),
                                  _createElementVNode("td", _hoisted_62, _toDisplayString(row.st_total), 1),
                                  _createElementVNode("td", _hoisted_63, _toDisplayString(row.st_under_3m), 1),
                                  _createElementVNode("td", _hoisted_64, _toDisplayString(row.st_3m_6m), 1),
                                  _createElementVNode("td", _hoisted_65, _toDisplayString(row.st_6m_1y), 1),
                                  _createElementVNode("td", _hoisted_66, _toDisplayString(row.st_1y_2y), 1),
                                  _createElementVNode("td", _hoisted_67, _toDisplayString(row.st_over_2y), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_68, "등록된 근속현황 정보가 없습니다."))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "facility" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                            _createTextVNode("mdi-home-city-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[52] || (_cache[52] = _createTextVNode("시설현황", -1))
                      ]),
                      (hasDayCareData.value)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_70, [
                            _cache[53] || (_cache[53] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "급여종류"),
                                _createElementVNode("th", null, "1인 생활실"),
                                _createElementVNode("th", null, "프로그램실")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.facility, (row, i) => {
                                return _withDirectives((_openBlock(), _createElementBlock("tr", {
                                  key: 'dc-'+i
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(row.fac_service || '-'), 1),
                                  _createElementVNode("td", _hoisted_71, _toDisplayString(row.fac_single_room || 0), 1),
                                  _createElementVNode("td", _hoisted_72, _toDisplayString(row.fac_program_room || 0), 1)
                                ])), [
                                  [_vShow, row.fac_single_room > 0 || row.fac_program_room > 0 || (!row.fac_room_total && !row.fac_room_1)]
                                ])
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (hasNursingHomeData.value)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_73, [
                            _cache[54] || (_cache[54] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "급여형태"),
                                _createElementVNode("th", null, "침실합계"),
                                _createElementVNode("th", null, "1인실"),
                                _createElementVNode("th", null, "2인실"),
                                _createElementVNode("th", null, "3인실"),
                                _createElementVNode("th", null, "4인실"),
                                _createElementVNode("th", null, "특실"),
                                _createElementVNode("th", null, "기타"),
                                _createElementVNode("th", null, "공동거실"),
                                _createElementVNode("th", null, "화장실"),
                                _createElementVNode("th", null, "욕실"),
                                _createElementVNode("th", null, "옥외공간")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.facility, (row, i) => {
                                return _withDirectives((_openBlock(), _createElementBlock("tr", {
                                  key: 'nh-'+i
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(row.fac_service || '-'), 1),
                                  _createElementVNode("td", _hoisted_74, _toDisplayString(row.fac_room_total || 0), 1),
                                  _createElementVNode("td", _hoisted_75, _toDisplayString(row.fac_room_1 || 0), 1),
                                  _createElementVNode("td", _hoisted_76, _toDisplayString(row.fac_room_2 || 0), 1),
                                  _createElementVNode("td", _hoisted_77, _toDisplayString(row.fac_room_3 || 0), 1),
                                  _createElementVNode("td", _hoisted_78, _toDisplayString(row.fac_room_4 || 0), 1),
                                  _createElementVNode("td", _hoisted_79, _toDisplayString(row.fac_room_special || 0), 1),
                                  _createElementVNode("td", _hoisted_80, _toDisplayString(row.fac_room_etc || 0), 1),
                                  _createElementVNode("td", _hoisted_81, _toDisplayString(row.fac_living || 0), 1),
                                  _createElementVNode("td", _hoisted_82, _toDisplayString(row.fac_toilet || 0), 1),
                                  _createElementVNode("td", _hoisted_83, _toDisplayString(row.fac_bath || 0), 1),
                                  _createElementVNode("td", _hoisted_84, _toDisplayString(row.fac_outdoor || 0), 1)
                                ])), [
                                  [_vShow, row.fac_room_total > 0 || row.fac_room_1 > 0]
                                ])
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!detail.value.facility?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, "등록된 시설현황 정보가 없습니다."))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_86, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                            _createTextVNode("mdi-car-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[56] || (_cache[56] = _createTextVNode("방문목욕 차량현황", -1))
                      ]),
                      (detail.value.vehicle?.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_87, [
                            _cache[57] || (_cache[57] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "차량대수"),
                                _createElementVNode("th", null, "차량번호")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.vehicle, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", _hoisted_88, _toDisplayString(row.veh_count), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.veh_number || '-'), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_89, "등록된 차량 정보가 없습니다.")),
                      _createElementVNode("div", _hoisted_90, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                            _createTextVNode("mdi-medical-bag", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[59] || (_cache[59] = _createTextVNode("복지용구 현황", -1))
                      ]),
                      (detail.value.equipment?.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_91, [
                            _cache[60] || (_cache[60] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "신고번호"),
                                _createElementVNode("th", null, "품목명"),
                                _createElementVNode("th", null, "제조사"),
                                _createElementVNode("th", null, "모델명"),
                                _createElementVNode("th", null, "용도"),
                                _createElementVNode("th", null, "비고")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.equipment, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", null, _toDisplayString(row.eq_report || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.eq_name || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.eq_manufacturer || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.eq_model || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.eq_purpose || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.eq_etc || '-'), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_92, "등록된 복지용구 정보가 없습니다."))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "cost" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                            _createTextVNode("mdi-currency-krw", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[62] || (_cache[62] = _createTextVNode("비급여 항목별 비용", -1))
                      ]),
                      (detail.value.cost?.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_94, [
                            _cache[63] || (_cache[63] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "항목"),
                                _createElementVNode("th", null, "산출근거"),
                                _createElementVNode("th", null, "1일 비용"),
                                _createElementVNode("th", null, "월(31일) 비용"),
                                _createElementVNode("th", null, "비고"),
                                _createElementVNode("th", null, "등록일")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.cost, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", null, _toDisplayString(row.cost_item || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.cost_basis || '-'), 1),
                                  _createElementVNode("td", _hoisted_95, _toDisplayString(formatCurrency(row.cost_daily)), 1),
                                  _createElementVNode("td", _hoisted_96, _toDisplayString(formatCurrency(row.cost_monthly)), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.cost_note || '-'), 1),
                                  _createElementVNode("td", _hoisted_97, _toDisplayString(formatDate(row.cost_reg_date)), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_98, "등록된 비급여비용 정보가 없습니다."))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "program" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_99, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                            _createTextVNode("mdi-calendar-star", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[65] || (_cache[65] = _createTextVNode("프로그램 운영 현황", -1))
                      ]),
                      (detail.value.program?.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_100, [
                            _cache[66] || (_cache[66] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "종류"),
                                _createElementVNode("th", null, "프로그램명"),
                                _createElementVNode("th", null, "대상인원"),
                                _createElementVNode("th", null, "진행주기"),
                                _createElementVNode("th", null, "장소")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.program, (row, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", null, _toDisplayString(row.prog_category || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.prog_name || '-'), 1),
                                  _createElementVNode("td", _hoisted_101, _toDisplayString(row.prog_target), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.prog_cycle || '-'), 1),
                                  _createElementVNode("td", null, _toDisplayString(row.prog_location || '-'), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_102, "등록된 프로그램 정보가 없습니다."))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "sales" }, {
                    default: _withCtx(() => [
                      (!salesInfo.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _createVNode(_component_v_icon, {
                              size: "64",
                              color: "grey-lighten-1"
                            }, {
                              default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                _createTextVNode("mdi-handshake-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            (salesLogs.value.length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_104, "아직 영업이 시작되지 않은 시설입니다."))
                              : (_openBlock(), _createElementBlock("p", _hoisted_105, "현재 진행 중인 영업이 없습니다.")),
                            _cache[68] || (_cache[68] = _createElementVNode("p", { class: "sales-empty-hint" }, "아래 '영업시작' 버튼을 클릭하여 이 시설에 대한 영업을 시작하세요.", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (salesInfo.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("table", _hoisted_106, [
                              _createElementVNode("tbody", null, [
                                (canSeeSalesDetail.value)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_107, [
                                      _cache[69] || (_cache[69] = _createElementVNode("th", null, "담당 조직", -1)),
                                      _createElementVNode("td", null, _toDisplayString(salesInfo.value.sales_org_name), 1),
                                      _cache[70] || (_cache[70] = _createElementVNode("th", null, "담당자", -1)),
                                      _createElementVNode("td", null, _toDisplayString(salesInfo.value.sales_user_name || '-'), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("tr", null, [
                                  _cache[71] || (_cache[71] = _createElementVNode("th", null, "영업 시작일", -1)),
                                  _createElementVNode("td", null, _toDisplayString(formatDate(salesInfo.value.sales_wdate)), 1),
                                  _cache[72] || (_cache[72] = _createElementVNode("th", null, "상태", -1)),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_chip, {
                                      size: "small",
                                      color: getSalesStatusColor(salesInfo.value.sales_status),
                                      variant: "flat"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "14",
                                          class: "mr-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(getSalesStatusIcon(salesInfo.value.sales_status)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" " + _toDisplayString(getSalesStatusLabel(salesInfo.value.sales_status)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"])
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _cache[73] || (_cache[73] = _createElementVNode("th", null, "메모", -1)),
                                  _createElementVNode("td", _hoisted_108, [
                                    _createVNode(_component_v_textarea, {
                                      modelValue: salesInfo.value.sales_note,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((salesInfo.value.sales_note) = $event)),
                                      placeholder: "영업 관련 메모를 입력하세요...",
                                      rows: "3",
                                      variant: "outlined",
                                      density: "compact",
                                      "hide-details": "",
                                      disabled: !hasPermission.value,
                                      onBlur: updateSalesNote
                                    }, null, 8, ["modelValue", "disabled"])
                                  ])
                                ])
                              ])
                            ]),
                            (hasPermission.value && salesInfo.value.sales_status === '영업중')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                  _createVNode(_component_v_btn, {
                                    variant: "flat",
                                    class: "btn-save",
                                    size: "small",
                                    onClick: convertSales,
                                    loading: salesLoading.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "16",
                                        class: "mr-1"
                                      }, {
                                        default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                          _createTextVNode("mdi-account-check-outline", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[75] || (_cache[75] = _createTextVNode(" 회원가입 ", -1))
                                    ]),
                                    _: 1
                                  }, 8, ["loading"]),
                                  _createVNode(_component_v_btn, {
                                    variant: "flat",
                                    class: "btn-stop",
                                    size: "small",
                                    onClick: openStopDialog
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "16",
                                        class: "mr-1"
                                      }, {
                                        default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                          _createTextVNode("mdi-pause-circle-outline", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[77] || (_cache[77] = _createTextVNode(" 영업 중단 ", -1))
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (salesLogs.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                  _createTextVNode("mdi-history", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" 영업 이력 (" + _toDisplayString(salesLogs.value.length) + "건) ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_112, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesLogs.value, (log) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: log.log_idx,
                                  class: _normalizeClass(["sales-log-item", getLogTypeClass(log.log_type)])
                                }, [
                                  _createElementVNode("div", _hoisted_113, [
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      color: getLogTypeColor(log.log_type)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getLogTypeIcon(log.log_type)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    (editingLogIdx.value === log.log_idx)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_v_textarea, {
                                            modelValue: editingLogContent.value,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingLogContent).value = $event)),
                                            rows: "2",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "",
                                            autofocus: ""
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("div", _hoisted_115, [
                                            _createVNode(_component_v_btn, {
                                              variant: "flat",
                                              class: "btn-save",
                                              size: "x-small",
                                              onClick: ($event: any) => (saveLogEdit(log.log_idx))
                                            }, {
                                              default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                                _createTextVNode("저장", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              variant: "text",
                                              class: "btn-cancel",
                                              size: "x-small",
                                              onClick: cancelLogEdit
                                            }, {
                                              default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                                _createTextVNode("취소", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ])
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("div", _hoisted_116, [
                                            _createVNode(_component_v_chip, {
                                              size: "x-small",
                                              color: getLogTypeColor(log.log_type),
                                              variant: "flat",
                                              class: "log-type-chip"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(getLogTypeLabel(log.log_type)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color"]),
                                            (canSeeSalesDetail.value)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(log.org_name) + " · " + _toDisplayString(log.u_name), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_118, _toDisplayString(log.log_content), 1),
                                          _createElementVNode("div", _hoisted_119, [
                                            _cache[82] || (_cache[82] = _createElementVNode("span", { class: "log-date-label" }, "시작", -1)),
                                            _createElementVNode("span", _hoisted_120, _toDisplayString(formatDateTime(log.log_wdate)), 1),
                                            (log.log_end_date)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _cache[81] || (_cache[81] = _createElementVNode("span", { class: "log-date-separator" }, "→", -1)),
                                                  _createElementVNode("span", _hoisted_121, _toDisplayString(getEndDateLabel(log.log_type)), 1),
                                                  _createElementVNode("span", _hoisted_122, _toDisplayString(formatDateTime(log.log_end_date)), 1),
                                                  (log.log_type !== 'start')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_123, "(" + _toDisplayString(getDuration(log.log_wdate, log.log_end_date)) + ")", 1))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 64))
                                  ]),
                                  (isAdmin.value && editingLogIdx.value !== log.log_idx)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          size: "x-small",
                                          variant: "text",
                                          onClick: ($event: any) => (startLogEdit(log))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: "14",
                                              color: "#607d8b"
                                            }, {
                                              default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                                                _createTextVNode("mdi-pencil-outline", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          size: "x-small",
                                          variant: "text",
                                          onClick: ($event: any) => (confirmDeleteLog(log.log_idx))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: "14",
                                              color: "#c62828"
                                            }, {
                                              default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                                                _createTextVNode("mdi-delete-outline", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 2),
            (!__props.embedded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    (detail.value.main?.cc_rdate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_127, "최근 갱신: " + _toDisplayString(formatDateTime(detail.value.main.cc_rdate)), 1))
                      : (detail.value.main?.cc_wdate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_128, "최초 수집: " + _toDisplayString(formatDateTime(detail.value.main.cc_wdate)), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_spacer),
                  (!salesInfo.value && currentUser.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (salesLogs.value.length > 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "sales-history-hint",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (detailTab.value = 'sales'))
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                  _createTextVNode("mdi-history", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" 영업이력 " + _toDisplayString(salesLogs.value.length) + "건 ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_btn, {
                          variant: "flat",
                          class: "btn-start",
                          onClick: startSales,
                          loading: salesLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "18",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                _createTextVNode("mdi-rocket-launch-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[87] || (_cache[87] = _createTextVNode(" 영업시작 ", -1))
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ], 64))
                    : (salesInfo.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "sales-status-badge",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (detailTab.value = 'sales')),
                          style: {"cursor":"pointer"}
                        }, [
                          _createVNode(_component_v_chip, {
                            size: "small",
                            color: getSalesStatusColor(salesInfo.value.sales_status),
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(getSalesStatusIcon(salesInfo.value.sales_status)), 1)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(getSalesStatusLabel(salesInfo.value.sales_status)), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]),
                          (canSeeSalesDetail.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_129, _toDisplayString(salesInfo.value.sales_org_name), 1),
                                (salesInfo.value.sales_user_name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_130, _toDisplayString(salesInfo.value.sales_user_name), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_131, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                _createTextVNode("mdi-alert-circle-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[89] || (_cache[89] = _createElementVNode("p", null, "시설 정보를 찾을 수 없습니다.", -1))
          ])),
    _createVNode(_component_v_dialog, {
      modelValue: stopDialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((stopDialog).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "stop-dialog-title" }, {
              default: _withCtx(() => [
                _cache[91] || (_cache[91] = _createElementVNode("span", null, "영업 중단", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "stop-dialog__close",
                  disabled: salesLoading.value,
                  "aria-label": "닫기",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (stopDialog.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_132)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[92] || (_cache[92] = _createElementVNode("p", { class: "mb-3" }, "영업 중단 사유를 입력해주세요.", -1)),
                _createVNode(_component_v_textarea, {
                  modelValue: stopReason.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((stopReason).value = $event)),
                  placeholder: "중단 사유를 상세히 작성해주세요...",
                  rows: "4",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  autofocus: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (stopDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-stop",
                  onClick: stopSales,
                  disabled: !stopReason.value.trim(),
                  loading: salesLoading.value
                }, {
                  default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                    _createTextVNode("중단", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: convertDialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((convertDialog).value = $event)),
      "max-width": "500",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "convert-dialog-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                    _createTextVNode("mdi-account-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[97] || (_cache[97] = _createTextVNode(" 회원 ID/PW 설정 ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "convert-dialog__close",
                  disabled: salesLoading.value,
                  "aria-label": "닫기",
                  onClick: cancelConvert
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_133)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[104] || (_cache[104] = _createElementVNode("p", { class: "convert-dialog-desc" }, "고객들이 사용할 ID와 비밀번호를 설정해주세요.", -1)),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _cache[102] || (_cache[102] = _createElementVNode("label", { class: "form-label" }, [
                      _createTextVNode("아이디 (ID) "),
                      _createElementVNode("span", { class: "required" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_136, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((convertForm.value.memberId) = $event)),
                        type: "text",
                        class: _normalizeClass(["native-input", { 'is-valid': convertForm.value.idChecked && convertForm.value.idAvailable, 'is-invalid': convertForm.value.idChecked && !convertForm.value.idAvailable }]),
                        placeholder: "아이디를 입력하세요",
                        onInput: onIdInputChange
                      }, null, 34), [
                        [_vModelText, convertForm.value.memberId]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "check-btn",
                        onClick: checkIdDuplicate,
                        disabled: !convertForm.value.memberId.trim() || idCheckLoading.value
                      }, [
                        (idCheckLoading.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              size: "14",
                              width: "2"
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("중복확인")
                            ], 64))
                      ], 8, _hoisted_137)
                    ]),
                    (convertForm.value.idChecked && convertForm.value.idAvailable)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_138, [
                          _createVNode(_component_v_icon, {
                            size: "12",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[99] || (_cache[99] = _createTextVNode(" 사용 가능한 아이디입니다. ", -1))
                        ]))
                      : (convertForm.value.idChecked && !convertForm.value.idAvailable)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_139, [
                            _createVNode(_component_v_icon, {
                              size: "12",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                                _createTextVNode("mdi-alert-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[101] || (_cache[101] = _createTextVNode(" 이미 사용 중인 아이디입니다. ", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_140, "기본값: 기관기호 (" + _toDisplayString(detail.value?.main?.cc_number) + ")", 1))
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _cache[103] || (_cache[103] = _createElementVNode("label", { class: "form-label" }, "비밀번호 (PW)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((convertForm.value.memberPw) = $event)),
                      type: "text",
                      class: "native-input",
                      placeholder: "비밀번호를 입력하세요"
                    }, null, 512), [
                      [_vModelText, convertForm.value.memberPw]
                    ]),
                    _createElementVNode("span", _hoisted_142, "기본값: 기관기호 (" + _toDisplayString(detail.value?.main?.cc_number) + ")", 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: cancelConvert
                }, {
                  default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-save",
                  onClick: doConvertSales,
                  loading: salesLoading.value,
                  disabled: !convertForm.value.idChecked || !convertForm.value.idAvailable
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[107] || (_cache[107] = _createTextVNode(" 확인 ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((snackbar).value = $event)),
      timeout: 2000,
      color: "success",
      location: "bottom"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbarText.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})